import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export function truncate(text: string, max: number): string {
  if (!text) return "";
  return text.length <= max ? text : text.slice(0, max - 1) + "…";
}

export function initials(name?: string | null): string {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/).slice(0, 2);
  return parts.map((p) => p.charAt(0).toUpperCase()).join("") || "?";
}

export function pluralize(n: number, one: string, many: string): string {
  return n === 1 ? one : many;
}

export function classNameByStatus(status: string): string {
  switch (status) {
    case "approved":
    case "paid":
    case "booked":
      return "bg-emerald-50 text-emerald-700 border-emerald-200";
    case "in_approval":
    case "review_needed":
    case "scheduled_for_payment":
    case "payment_pending":
      return "bg-amber-50 text-amber-700 border-amber-200";
    case "rejected":
    case "payment_failed":
      return "bg-red-50 text-red-700 border-red-200";
    case "handed_off":
    case "archived":
      return "bg-blue-50 text-blue-700 border-blue-200";
    default:
      return "bg-status-neutral-bg text-status-neutral-text border-border-default";
  }
}

export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function uuid(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
